import { Get, Post, Put } from "../Request/Api";

export default {
  state: {
    memberShipChoosePlan: null,
    Membership: [],
    MembershipPayment: [],
    BillingDetailsByUserId: [],
    MembershipByUserId: [],
    MembershipInvoicesByUserId: [],
    MembershipOverviewByUserId: [],
    ProfileMembershipOverviewByUserId: [],
    NewMembershipChanges: {
      Status: true,
      Message: null,
      Data: [
        {
          Id: 1,
          Name: "Starter",
          Description:
            "For access to special resources and to start taking classes",
          Price: 0,
          IsInstructor: false,
          Permissions: [
            {
              Id: 1,
              MembershipModuleId: 1,
              Name: "Course Registration",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 2,
              MembershipModuleId: 1,
              Name: "Advanced Course Access",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 3,
              MembershipModuleId: 2,
              Name: "Practitioner Profile",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 4,
              MembershipModuleId: 3,
              Name: "Logo Usage",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 5,
              MembershipModuleId: 4,
              Name: "50–75% Off Course Retakes",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 6,
              MembershipModuleId: 6,
              Name: "Video & Resource Library",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 7,
              MembershipModuleId: 5,
              Name: "Interactive Discussion Forum",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 8,
              MembershipModuleId: 7,
              Name: "Founder Video Archive",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 9,
              MembershipModuleId: 7,
              Name: "Study Group Listings",
              IsAllowed: false,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 10,
              MembershipModuleId: 8,
              Name: "Community Newsletters",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
          ],
        },
        {
          Id: 2,
          Name: "Access",
          Description:
            "Ideal for those primarily interested in BodyTalk Access self and home care",
          Price: 5,
          IsInstructor: false,
          Permissions: [
            {
              Id: 11,
              MembershipModuleId: 1,
              Name: "Course Registration",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 12,
              MembershipModuleId: 1,
              Name: "Advanced Course Access",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 13,
              MembershipModuleId: 2,
              Name: "Practitioner Profile",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 14,
              MembershipModuleId: 3,
              Name: "Logo Usage",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 15,
              MembershipModuleId: 4,
              Name: "50–75% Off Course Retakes",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 16,
              MembershipModuleId: 6,
              Name: "Video & Resource Library",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 17,
              MembershipModuleId: 5,
              Name: "Interactive Discussion Forum",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 18,
              MembershipModuleId: 7,
              Name: "Founder Video Archive",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 19,
              MembershipModuleId: 8,
              Name: "Study Group Listings",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 20,
              MembershipModuleId: 8,
              Name: "Community Newsletters",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
          ],
        },

        {
          Id: 3,
          Name: "Standard",
          Description:
            "Ideal for those ready to learn and explore all they can about BodyTalk, MindScape and BreakThrough",
          Price: 12.5,
          IsInstructor: false,
          Permissions: [
            {
              Id: 21,
              MembershipModuleId: 1,
              Name: "Course Registration",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 22,
              MembershipModuleId: 1,
              Name: "Advanced Course Access",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 23,
              MembershipModuleId: 2,
              Name: "Practitioner Profile",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 24,
              MembershipModuleId: 3,
              Name: "Logo Usage",
              IsAllowed: false,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 25,
              MembershipModuleId: 4,
              Name: "50–75% Off Course Retakes",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 26,
              MembershipModuleId: 6,
              Name: "Video & Resource Library",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 27,
              MembershipModuleId: 5,
              Name: "Interactive Discussion Forum",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 28,
              MembershipModuleId: 7,
              Name: "Founder Video Archive",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 29,
              MembershipModuleId: 7,
              Name: "Study Group Listings",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 30,
              MembershipModuleId: 8,
              Name: "Community Newsletters",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
          ],
        },
        {
          Id: 4,
          Name: "Practitioner",
          Description:
            "For those who passed the Certified BodyTalk Practitioner exam and want to practice publicly and keep learning",
          Price: 25,
          IsInstructor: false,
          Permissions: [
            {
              Id: 31,
              MembershipModuleId: 1,
              Name: "Course Registration",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 32,
              MembershipModuleId: 1,
              Name: "Advanced Course Access",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 33,
              MembershipModuleId: 2,
              Name: "Practitioner Profile",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 34,
              MembershipModuleId: 3,
              Name: "Logo Usage",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 35,
              MembershipModuleId: 4,
              Name: "50–75% Off Course Retakes",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 36,
              MembershipModuleId: 6,
              Name: "Video & Resource Library",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 37,
              MembershipModuleId: 5,
              Name: "Interactive Discussion Forum",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },

            {
              Id: 38,
              MembershipModuleId: 7,
              Name: "Founder Video Archive",
              IsAllowed: true,
              LimitType: 1,
              MembershipName: "Starter",
            },
            {
              Id: 39,
              MembershipModuleId: 8,
              Name: "Study Group Listings",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
            {
              Id: 40,
              MembershipModuleId: 8,
              Name: "Community Newsletters",
              IsAllowed: true,
              LimitType: 0,
              MembershipName: "Starter",
            },
          ],
        },
      ],
      Error: null,
    },
    User: {
      FirstName: "",
      LastName: "",
      Email: "",
      Phone: null,
      Password: null,
      membership: null,
      CPassword: null,
    },
  },
  getters: {
    GetMemberShip(state: any) {
      return state.NewMembershipChanges;
    },
    GetUserData(state: any) {
      return state.User;
    },
    getMembershipPayment(state: any) {
      return state.MembershipPayment;
    },
    getBillingDetailsByUserId(state: any) {
      return state.BillingDetailsByUserId;
    },
    getMembershipByUserId(state: any) {
      return state.MembershipByUserId;
    },
    getMembershipInvoicesByUserId(state: any) {
      return state.MembershipInvoicesByUserId;
    },
    getMembershipOverviewByUserId(state: any) {
      return state.MembershipOverviewByUserId;
    },
    getProfileMembershipOverviewByUserId(state: any) {
      return state.ProfileMembershipOverviewByUserId.Data;
    },
  },
  actions: {
    // async GetAllMembership({ commit }: any, payload: any) {
    //   return await Get("Membership/GetMemberships").then((res) => {
    //     commit("SetAllMembership", res.data);
    //     console.log(res);
    //   });
    // },
    async UserData({ commit }: any, payload: any) {
      commit("setUserData", payload);
    },
    async resetStateAction({ commit }:any) {
      commit('resetState');
    },
    async MembershipPayment({ commit }: any, payload: any) {
      return await Post("Membership/MembershipPayment", payload).then((res) => {
        return res.data;
      });
    },
    async InstructorMembershipPayment({ commit }: any, payload: any) {
      return await Put("Membership/InstructorMembershipPayment", payload).then((res) => {
        return res.data;
      });
    },
    async SubmitHardshipApplication({ commit }: any, payload: any) {
      return await Post("HardshipApplication/SubmitHardshipApplication", payload).then((res) => {
        return res.data;
      });
    },
    async UpdateProfileMembershipOveriewCards({ commit }: any, payload: any) {
      return await Post(
        "User/UpdateProfileMembershipOveriewCards",
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async EditMembershipPayment({ commit }: any, payload: any) {
      return await Put("Membership/UpdateBillingDetails", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GetBillingDetailsByUserId({ commit }: any, payload: any) {
      return await Get(
        `Membership/GetBillingDetailsByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetBillingDetailsByUserId", res.data);
        return res.data;
      });
    },
    async GetMembershipByUserId({ commit }: any, payload: any) {
      return await Get(
        `Membership/GetMembershipByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetMembershipByUserId", res.data);
        return res.data;
      });
    },
    async GetMembershipInvoicesByUserId({ commit }: any, payload: any) {
      return await Get(
        `Invoices/GetMembershipInvoicesByUserId/${payload.id}`
      ).then((res) => {
        commit("SetMembershipInvoicesByUserId", res.data);
        return res.data;
      });
    },
    async GetMembershipOverviewByUserId({ commit }: any, payload: any) {
      return await Get(
        `User/GetMembershipOverviewByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetMembershipOverviewByUserId", res.data);
        return res.data;
      });
    },
    async GetProfileMembershipOveriewCardsByUserId(
      { commit }: any,
      payload: any
    ) {
      return await Get(
        `User/GetProfileMembershipOveriewCardsByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetProfileMembershipOveriewCardsByUserId", res.data);
        return res.data;
      });
    },
  },
  mutations: {
    resetState(state:any) {
      state.User.FirstName = '';
      state.User.LastName = '';
      state.User.Email = '';
      state.User.Phone = null;
      state.User.Password = null;
      state.User.membership = null;
      state.User.CPassword = null;
    },
    setUserData(state: any, payload: any) {
      if (payload.id) {
        state.User.membership = payload.id;
      } else {
        state.User.FirstName = payload.FirstName;
        state.User.LastName = payload.LastName;
        state.User.Email = payload.Email;
        state.User.Phone = payload.Phone;
        state.User.Password = payload.Password;
        state.User.CPassword = payload.CPassword;
        state.User.Language = payload.Language;
        state.User.SubscribeToNewsletter = payload.SubscribeToNewsletter;
        state.User.TermsAndConditions = payload.TermsAndConditions;
      }
    },
    SetAllMembership(state: any, payload: any) {
      state.Membership = payload;
    },
    SetBillingDetailsByUserId(state: any, payload: any) {
      state.BillingDetailsByUserId = payload;
    },
    SetMembershipByUserId(state: any, payload: any) {
      state.MembershipByUserId = payload;
    },
    SetMembershipInvoicesByUserId(state: any, payload: any) {
      state.MembershipInvoicesByUserId = payload;
    },
    SetMembershipOverviewByUserId(state: any, payload: any) {
      state.MembershipOverviewByUserId = payload;
    },
    SetProfileMembershipOveriewCardsByUserId(state: any, payload: any) {
      state.ProfileMembershipOverviewByUserId = payload;
    },
  },
};
